import { $tenant } from '@msdk/common'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilValue } from 'recoil'

export function NoTenantHome() {
  const tenant = useRecoilValue($tenant)
  const navigate = useNavigate()

  useEffect(() => {
    navigate(`/${tenant}`)
  }, [])

  return <></>
}
